"use client";

import { Drawer } from "@mui/material";
import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";

type NavSubItem = {
  label: string;
  href: string;
};

type NavItem = {
  label: string;
  submenu: NavSubItem[];
};

type HamburgerMenuProps = {
  navItems: NavItem[];
};

export default function HamburgerMenu({ navItems }: HamburgerMenuProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const onClick = () => setIsOpen((prev) => !prev);

  return (
    <>
      <button
        className={`burger ${isOpen ? "open" : ""}`}
        onClick={onClick}
        aria-label="Toggle menu"
        aria-expanded={isOpen}
      >
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </button>
      <Drawer open={isOpen} onClose={onClick} anchor="right">
        <nav className="mobile-drawer-nav" aria-label="Mobile navigation">
          <ul className="mobile-nav-list">
            {navItems.map((item) => (
              <li key={item.label} className="mobile-nav-item">
                <details>
                  <summary className="mobile-nav-summary">{item.label}</summary>
                  <ul className="mobile-submenu-list">
                    {item.submenu.map((subItem) => (
                      <li key={subItem.label} className="mobile-submenu-item">
                        <a
                          href={subItem.href}
                          className="mobile-submenu-link"
                          onClick={onClick}
                        >
                          {subItem.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </details>
              </li>
            ))}
          </ul>
        </nav>
        <a
          style={{ margin: "auto" }}
          href="tel:6515714848
"
        >
          <p className="phone">
            <PhoneIcon />
            (651) 571-4848
          </p>
        </a>
      </Drawer>
    </>
  );
}
